import {UserPermission} from '../../shared-components/user/user-permission.model';

export class DataQueryPermissions {

	// Properties
	canUserCreatePrivateQuery = false;
	canUserCreateSchoolQuery = false;
	canUserCreateDistrictQuery = false;
	canUserTakeOwnershipOfQuery = false;
	canUserQueryAllYears = false;
	canUserViewSQL = false;
	canPublishToIntegration = false;
	canUserModifySchoolQuery = false;
	canUserModifyDistrictQuery = false;

	// Methods
	constructor(
		permissions: UserPermission[],
		V10: boolean
	) {
		// Copied from JS app
		if (V10) {
			if (permissions.find(permission =>
				permission.PermissionName == 'Take Ownership of Existing Query' &&
				permission.PrivilegeId == 2507
			)) {
				this.canUserCreatePrivateQuery = true;
				this.canUserCreateSchoolQuery = true;
				this.canUserCreateDistrictQuery = true;
				this.canUserTakeOwnershipOfQuery = true;
				this.canUserQueryAllYears = true;
				this.canUserModifySchoolQuery = true;
				this.canUserModifyDistrictQuery = true;
			}
			else {
				if (permissions.find(permission =>
					permission.PermissionName == 'Add Edit Private Query' &&
					permission.PrivilegeId == 2504
				)) {
					this.canUserCreatePrivateQuery = true;
				}
				if (permissions.find(permission =>
					permission.PermissionName == 'Publish Query to School' &&
					permission.PrivilegeId == 2505
				)) {
					this.canUserCreateSchoolQuery = true;
				}
				if (permissions.find(permission =>
					permission.PermissionName == 'Publish Query to District' &&
					permission.PrivilegeId == 2506
				)) {
					this.canUserCreateDistrictQuery = true;
				}
				if (permissions.find(permission =>
					permission.PermissionName == 'Can Query All Years' &&
					permission.PrivilegeId == 2508
				)) {
					this.canUserQueryAllYears = true;
				}
			}
			if (permissions.find(permission =>
				permission.PermissionName == 'View SQL Query' &&
				permission.PrivilegeId == 2522
			)) {
				this.canUserViewSQL = true;
			}
			if (permissions.find(permission =>
				permission.PermissionName == 'Publish to Integration Services' &&
				permission.PrivilegeId == 2524
			)) {
				this.canPublishToIntegration = true;
			}
		}
		else {
			this.canUserModifySchoolQuery = false;
			this.canUserModifyDistrictQuery = false;
			if (permissions.find(permission =>
				permission.PermissionCode == 'SD_ESDG' || permission.PermissionCode == 'SD_VSDG'
			)) {
				this.canUserCreatePrivateQuery = true;
				this.canUserCreateSchoolQuery = true;
				this.canUserCreateDistrictQuery = true;
				if (permissions.find(permission =>
					permission.PermissionCode == 'SD_MSLDGT'
				)) {
					this.canUserTakeOwnershipOfQuery = true;
					this.canUserModifySchoolQuery = true;
				}
				if (permissions.find(permission =>
					permission.PermissionCode == 'SD_MDWDGT'
				)) {
					this.canUserModifyDistrictQuery = true;
					this.canUserTakeOwnershipOfQuery = true;
				}
				if (permissions.find(permission =>
					permission.PermissionCode == 'SUI_DQVS'
				)) {
					this.canUserViewSQL = true;
				}
			}
		}
	}
}
